export const getFullName = (profile) => `${profile?.fname || ""} ${profile?.name || ""} ${profile?.lname || ""}`